// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"113":"bf35ec56","512":"0c0fca49","666":"bf35ec56","924":"bf35ec56"}[chunkId] + ".chunk.css");